import { render, staticRenderFns } from "./MoneyCodes.vue?vue&type=template&id=9814e4f0&scoped=true"
import script from "./MoneyCodes.vue?vue&type=script&lang=js"
export * from "./MoneyCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9814e4f0",
  null
  
)

export default component.exports